import { isEmbedded } from '../../public/lib/PageHelpers.js';

const FormHeaderBlock = ({ styles, className, formId }) => {
    const headerImage = !styles?.fullPageImage && styles?.headerImage;
    const headerColor = !styles?.fullPageImage && styles?.headerColor;
    const headerPadding = `${styles?.headerHeight || 0}px`;
    const logo = !styles?.logoDisabled && styles?.logo;
    const headerPosition = styles?.headerImagePosition
        ? `50% ${styles?.headerImagePosition}%`
        : 'center';

    if (!headerImage && !headerColor && !logo) {
        return null;
    }

    if (isEmbedded()) {
        // Don't show header when embedded
        return null;
    }

    return (
        <div
            className={`w-full py-6 ${!logo && headerImage ? 'min-h-64' : ''} ${className} flex items-center justify-center`}
            style={{
                backgroundImage: `url(${headerImage})`,
                backgroundSize: 'cover',
                backgroundPosition: headerPosition,
                backgroundColor: headerColor,
                paddingTop: headerPadding,
                paddingBottom: headerPadding,
            }}
        >
            {!!logo && (
                <img
                    src={`/forms/${formId}/logo?${logo}`}
                    alt="Logo"
                    className={`max-h-48 ${styles?.logoShadow ? 'shadow-lg' : ''}`}
                />
            )}
        </div>
    );
};

export default FormHeaderBlock;
